import React from 'react';
import styled, { withTheme } from 'styled-components';
import HeroBannerSection from '../shared/HeroBannerSection';
import HelpSection from '../shared/HelpSection';
import NotificationSection from '../shared/NotificationSection';
import BannerSection from '../shared/BannerSection';
import { getBannerTracking } from '../../../../lib/helpers/bannerTracking.helpers';
import { DATA_TRACK_CLICK_HERO_BANNER_SECTION } from '../../../../lib/constants';
import { toSlug } from '../../../../lib/utils';

const SectionComponents = {
  HeroBannerSection,
  HelpSection,
  NotificationSection,
  BannerSection,
};

const ExtensionLandingContainer = styled.div`
  h1, h2, h3, h4, h5, p, span, ul, li {
    margin: 0;
    padding: 0;
  }

  button, a {
    @media screen and (max-width: ${(p) => p.theme.breakpoint.mobile}px) {
      width: 100%;
    }
  }

  .content-section,
  .content-section--hero {
    width: 100%;
    max-width: 100vw;
    padding: 48px 16px;

    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.tablet}px) {
      max-width: 85vw;
      padding: 48px 0;
    }
    
    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
      width: 1224px;
      padding: 80px 108px;
    }
  }
`;

const ExtensionLanding = (props) => {
  const {
    pageData: {
      contentSections = [],
      extensionBrowserLinkConfig,
    },
    client,
  } = props;

  const {
    buttonText,
    buttonUrl
  } = { ...(client && extensionBrowserLinkConfig?.[client]) };

  return (
    <ExtensionLandingContainer>
      { contentSections && contentSections.map((section) => {
        const SectionComponent = SectionComponents[section.renderComponent] || null;
        const sectionProps = { ...section };
        switch (section.renderComponent) {
          case 'HeroBannerSection': {
            const ctaButtonText = buttonText || section.buttonText;
            const ctaButtonUrl = buttonUrl || section.buttonUrl;

            sectionProps.heroImageUrl = section.imageUrl;
            sectionProps.portraitTabletHeroImageUrl = section.imageUrl;
            sectionProps.classNames = 'extension-landing';
            sectionProps.heading = section.title;
            sectionProps.subheading = section.subtitle;

            if (ctaButtonText || ctaButtonUrl) {
              sectionProps.buttons = [{
                buttonText: ctaButtonText,
                variant: 'primary',
                size: 'medium',
                theme: 'light',
                url: ctaButtonUrl,
                rel: 'noopener noreferrer',
                target: '_blank',
                bannerTracking: getBannerTracking({
                  bannerImgUrl: section.imageUrl,
                  bannerLocation: DATA_TRACK_CLICK_HERO_BANNER_SECTION,
                  linkName: toSlug(ctaButtonText),
                }),
              }];
            }

            break;
          }
          case 'BannerSection':
            if (buttonText || buttonUrl) {
              sectionProps.buttonText = buttonText || section.buttonText;
              sectionProps.buttonUrl = buttonUrl || section.buttonUrl;
            }
            break;
          default:
            break;
        }

        return (SectionComponent
           && (
           <SectionComponent
             browserConfig={extensionBrowserLinkConfig}
             {...sectionProps} />
           ));

      })}
    </ExtensionLandingContainer>
  );
};

export default withTheme(ExtensionLanding);
